import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Table } from 'react-bootstrap';
import { get, keyBy } from 'lodash';
import { isSoloLearningAsset } from '../../utils/UserLearningAssetUtils';
import RichTextDisplay from '../../components/RichTextDisplay';

import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import { SECTION_ITEM_TYPES } from '../../Constants';
import LikertScale from './LikertScale';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

import VerbText from '../../components/VerbText';

class ReviewPreviousActivitiesSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reviewAnswersByLearningAssetId: {}
        };
    }

    static propTypes = {
        name: PropTypes.string,
        nextSectionName: PropTypes.string,
        content: PropTypes.shape({
            description: PropTypes.string,
            questionsToDisplay: PropTypes.arrayOf(
                PropTypes.shape({
                    questionType: PropTypes.string,
                    questionId: PropTypes.string
                })
            )
        }),
        canMoveToNext: PropTypes.func,
        canMoveToPrevious: PropTypes.func,
        onChange: PropTypes.func,
        currentUser: PropTypes.object,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        learningAssetType: PropTypes.string,
        fetchReviewData: PropTypes.func,
        currentUserTrack: PropTypes.object,
        isRefSheet: PropTypes.bool,
    };

    componentDidMount() {
        const { canMoveToPrevious, canMoveToNext, onChange, fetchReviewData } = this.props;

        if (canMoveToPrevious) canMoveToPrevious(true);
        if (canMoveToNext) canMoveToNext(true);

        const isCompleted = true;
        const isAnswered = true;
        if (onChange) onChange(null, isCompleted, isAnswered);
        return fetchReviewData().then(({ reviewAnswersByLearningAssetId }) => {
            this.setState({ reviewAnswersByLearningAssetId });
        });
    }

    /**
     *
     * @return {Array}
     * @private
     */
    _generateAnswers = () => {
        const { reviewAnswersByLearningAssetId } = this.state;
        const { learningAssetType, content, currentUser, nextSectionName } =
            this.props;

        return (content.questionsToDisplay || []).map((question, index) => {
            const formattedSectionType = question.type?.toLocaleUpperCase();
            const isLikert = formattedSectionType === SECTION_ITEM_TYPES.LIKERT_CONTENT;
            const answerRows = [];
            const answerItems = get(
                reviewAnswersByLearningAssetId,
                `[${question.learningAssetId}][${question.sectionItemId}]`,
                []
            );
            const answerItemsByUserId = keyBy(answerItems, 'userProfileId');

            ([currentUser]).forEach((member) => {
                const answerItem = answerItemsByUserId[member._id] || {};
                let answersList = answerItem.answer;
                const isSolo = isSoloLearningAsset(learningAssetType);
                if (answerItemsByUserId[member._id]) {
                    if (formattedSectionType === SECTION_ITEM_TYPES.CHOOSE_MANY_CONTENT) {
                        const answersString = answerItem.answer
                            .split(', ')
                            .reduce((acc, answer) => `${acc}\n <p>${answer}</p>`, '');
                        answersList = `<div>${answersString}</div>`;
                    }
                    const displayAnswer =
                        typeof answersList !== 'string' ? (
                            <span className={'review-prev-activities-answer-text'}>{answersList}</span>
                        ) : (
                            <RichTextDisplay
                                className={'review-prev-activities-answer-text'}
                                htmlToDisplay={answersList}
                                currentUser={currentUser}
                                nextSectionName={nextSectionName}
                            />
                        );
                    answerRows.push(
                        <div className={'row review-answer-row'}>
                            {!isSolo && (
                                <span className={'review-prev-activities-name'}>{answerItem.userFirstName}:</span>
                            )}
                            {isLikert ? (
                                <LikertScale
                                    start={answerItem.start}
                                    length={answerItem.length}
                                    userValue={answerItem.answer}
                                />
                            ) : (
                                displayAnswer
                            )}
                        </div>
                    );
                } else {
                    answerRows.push(
                        <div className={'row review-answer-row'}>
                            {!isSolo && <span className={'review-prev-activities-name'}>{member.firstName}:</span>}
                        </div>
                    );
                }
            });

            return (
                <tr key={`${question.id}-${index}`}>
                    <td className={'review-prev-activities-label-cell'}>{question.label}</td>
                    <td>
                        <table>
                            <tbody>
                                <tr
                                    key={'you'}
                                    className={cns('review-prev-activities-answer', {
                                        likert: isLikert
                                    })}
                                >
                                    {answerRows}
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        });
    };

    _renderAnswersMobileView = () => {
        const { reviewAnswersByLearningAssetId } = this.state;
        const { learningAssetType, content, currentUser, nextSectionName } =
            this.props;

        return (content.questionsToDisplay || []).map((question, index) => {
            const formattedSectionType = question.type?.toLocaleUpperCase();
            const isLikert = formattedSectionType === SECTION_ITEM_TYPES.LIKERT_CONTENT;
            const answerRows = [];
            const answerItems = get(
                reviewAnswersByLearningAssetId,
                `[${question.learningAssetId}][${question.sectionItemId}]`,
                []
            );
            const answerItemsByUserId = keyBy(answerItems, 'userProfileId');

            ([currentUser]).forEach((member) => {
                const answerItem = answerItemsByUserId[member._id] || {};
                let answersList = answerItem.answer;
                const isSolo = isSoloLearningAsset(learningAssetType);
                if (answerItemsByUserId[member._id]) {
                    if (formattedSectionType === SECTION_ITEM_TYPES.CHOOSE_MANY_CONTENT) {
                        const answersString = answerItem.answer
                        .split(', ')
                        .reduce((acc, answer) => {
                            let answerStr = answer;
                            const div = document.createElement("div");
                            div.innerHTML = answer;
                            const pTags = div.getElementsByTagName("p");   // or getElementsByClassName if you prefer
                            if (pTags && pTags.length && pTags[0]?.innerHTML) {
                                let pHTML = pTags[0].innerHTML;
                                answerStr = pHTML;
                            }
                            return `${acc}\n <li class="answer-list-item">${answerStr}</li>`;
                        }, '')

                        answersList = `<div>${answersString}</div>`;
                    } else if (formattedSectionType === SECTION_ITEM_TYPES.CHOOSE_ONE_CONTENT) {
                        let answerStr = answerItem.answer;
                        const div = document.createElement("div");
                        div.innerHTML = answerItem.answer;
                        const pTags = div.getElementsByTagName("p");   // or getElementsByClassName if you prefer
                        if (pTags && pTags.length && pTags[0]?.innerHTML) {
                            let pHTML = pTags[0].innerHTML;
                            answerStr = pHTML;
                        }
                        answersList = `<div><li class="answer-list-item">${answerStr}</li></div>`;
                    }
                    const displayAnswer =
                        typeof answersList !== 'string' ? (
                            <span className={'review-prev-activities-answer-text'}>{answersList}</span>
                        ) : (
                            <div className="form-input-answer">
                                <RichTextDisplay
                                    className={'review-prev-activities-answer-text'}
                                    htmlToDisplay={answersList}
                                    currentUser={currentUser}
                                    nextSectionName={nextSectionName}
                                />
                            </div>
                        );
                    answerRows.push(
                        <div className={'row review-answer-row'}>
                            {!isSolo && (
                                <span className={'review-prev-activities-name'}>{answerItem.userFirstName}:</span>
                            )}
                            {isLikert ? (
                                <LikertScale
                                    start={answerItem.start}
                                    length={answerItem.length}
                                    userValue={answerItem.answer}
                                />
                            ) : (
                                displayAnswer
                            )}
                        </div>
                    );
                } else {
                    answerRows.push(
                        <div className={'row review-answer-row'}>
                            {!isSolo && <span className={'review-prev-activities-name'}>{member.firstName}:</span>}
                        </div>
                    );
                }
            });

            return (
                <div key={`${question.id}-${index}`}>
                    <div className={'review-prev-activities-label-cell mobile'}>{question.label}</div>
                    <div
                        key={'you'}
                        className={cns('review-prev-activities-answer', {
                            likert: isLikert
                        })}
                    >
                        {answerRows.map((answerRow, index) => {
                            return (
                                <div key={index} className={'row review-answer-row'}>
                                    {answerRow}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        });
    }

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            content: { description = '' },
            sectionId,
            sectionItemId,
            hideBookmark,
            learningAssetType,
            currentUserTrack,
            isRefSheet = false,
        } = this.props;
        let hideTableHeaders = false;
        if (currentUserTrack && currentUserTrack.track) {
            hideTableHeaders = currentUserTrack?.track?.hideQuestionAndResultsHeaders ?? false;
          }
        const currentWidth = window.outerWidth;
        const isMobile = currentWidth <= 480;
        return (
            <div className={'review-prev-activities'}>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={'playerContent'}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    {isMobile ? (
                        <div className={'mobileView'}>
                            {this._renderAnswersMobileView()}
                        </div>
                    )
                    :(
                        <Table striped={false} bordered={false} hover={false} className={'shortEssayItemAnswersList'}>
                            {!hideTableHeaders && (
                                <thead>
                                    <tr>
                                        <th />
                                        <th>
                                            <VerbText
                                                messageId={'WORKSPACE_SHOW_PREV_RESPONSE'}
                                                defaultMessage={'Response'}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                            )}
                            <tbody>{this._generateAnswers()}</tbody>
                        </Table>
                    )}
                </div>
            </div>
        );
    }
}

export const ReviewPreviousActivitiesSlideComponent = ReviewPreviousActivitiesSlide;
export default TrackPlayerSlideComponent(ReviewPreviousActivitiesSlide);
